import Vue from 'vue'
import store from '@/store'
let ProblemUserSubmitDlgConstructor = Vue.extend(require('./main.vue'))

let instance

var problemUserSubmitDlg = function (options) {
  options = options || {}
  if (!instance) {
    instance = new ProblemUserSubmitDlgConstructor({
      data: options,
      store: store
    })
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
  }

  // instance.vm.loadData()
  instance.vm.guid = options.guid
  instance.vm.show = true
  return instance.vm
}

export default problemUserSubmitDlg



// WEBPACK FOOTER //
// ./src/components/problemUserSubmitDlg/src/main.js